@import "~@uipath/apollo-core/src/scss/base-host.scss";

@import "./components/moreTileMenuV3.scss";
@import "../../constants/scrollbar.scss";

@mixin border-right {
  border-right-style: solid;
  border-right-color: var(--color-border-de-emp);
  border-right-width: $border-thick-s;
}

:host {
  position: relative;
  z-index: 2;
}

.pt-menu-group {
  @include border-right();
  display: flex;
  flex-direction: column;
  width: 68px;
  height: 100%;
  font-family: $font-normal;
  padding-top: 16px;
  box-sizing: border-box;
  background-color: var(--color-background);

  &.expanded {
    width: 300px;
    max-height: 100%;
    @include scroll-on-hover();

    .more-products {
      padding-left: calc($pad-xl + $pad-xxl);
      @include poppins-title();
    }
  }
}

.pt-top-button {
  display: flex;
  flex-direction: column;
  z-index: 1; // moving the content one layer up so the fillers cannot interfer on old browsers
}

.pt-filler {
  height: max(100%, 56px);
}

.pt-bottom-button {
  display: flex;
  flex-direction: column;
}
